import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
  } from '@/components/ui/alert-dialog';
  import { useQueryClient } from '@tanstack/react-query';
  
  export type DeletePortfolioConfirmationProps = {
    isOpen: boolean;
    handleOpen: (boolean: boolean) => void;
    portfolioId: string;
    organizationId: string;
  };
  
  export const DeletePortfolioConfirmation = ({
    isOpen,
    handleOpen,
    portfolioId,
    organizationId,
  }: DeletePortfolioConfirmationProps) => {
    const queryClient = useQueryClient();
    const [deletingPortfolio, setDeletingPortfolio] = useState(false);
  
    return (
      <AlertDialog open={isOpen} onOpenChange={handleOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
            <AlertDialogDescription>
              This action cannot be undone. This will permanently delete this
              accounts grouping and remove all the data inside it from our servers.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction
              onClick={async e => {
                e.preventDefault();
                setDeletingPortfolio(true);
                await deletePortfolio(portfolioId);
                queryClient.invalidateQueries({
                  queryKey: ['getPortfolios', organizationId],
                });
                setDeletingPortfolio(false);
                handleOpen(false);
              }}
              disabled={deletingPortfolio}
              className="bg-red-600 hover:bg-red-500 dark:text-white dark:hover:bg-red-700"
            >
              {deletingPortfolio ? 'Processing...' : 'Continue'}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    );
  };